import { css } from '@microsoft/fast-element';
export const foundationErrorDialogStyles = css `
  :host {
    --design-unit: 3;
    --dialog-max-width: 358px;
    --dialog-min-width: 358px;
    --dialog-max-height: 128px;
    --error-details-min-height: 40px;
  }

  .title {
    margin-top: calc(var(--design-unit) * 2px);
    font-size: 14px;
  }

  .details {
    font-size: 12px;
    overflow: hidden;
    min-height: var(--error-details-min-height);
  }
`;
